// extracted by mini-css-extract-plugin
export default {"cardContainer":"AddLabel_cardContainer__63LvT","header":"AddLabel_header__nbRci","body":"AddLabel_body__pxP59","actions":"AddLabel_actions__1+WKs"};